import React from "react";
import {Recog} from "../components";
import "./../App.css";
const Recog_page = () => {
  return (
    <div>
     <Recog />
      
    </div>
  );
};

export default Recog_page;
